import React from "react";
import styled from "styled-components";

const Spinner = styled.div`
  width: 50px;
  aspect-ratio: 1;
  border-radius: 50%;
  background: ${(
    p
  ) => `radial-gradient(farthest-side, ${p.background} 94%, #0000) top/8px 8px
      no-repeat,
    conic-gradient(#0000 30%, ${p.background});`};
  mask: radial-gradient(farthest-side, #0000 calc(100% - 8px), #000 0);
  animation: l13 1s infinite linear;
  -webkit-mask: radial-gradient(farthest-side, #0000 calc(100% - 8px), #000 0);
  animation: l13 1s infinite linear;

  @keyframes l13 {
    100% {
      transform: rotate(1turn);
    }
  }
`;

const SpinnerLoader = (props) => {
  const { background = "#999", style } = props;

  return (
    <>
      <Spinner background={background} style={style} />
    </>
  );
};

export default SpinnerLoader;
